interface CardKPIProps {
  label: string
  value: number
  format?: 'currency' | 'number' | 'percentage'
  isAlert?: boolean
}

export function CardKPI({ label, value, format = 'number', isAlert = false }: CardKPIProps) {
  const formatValue = () => {
    if (format === 'currency') {
      return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
    }
    if (format === 'percentage') {
      return `${value.toFixed(1)}%`
    }
    return value.toLocaleString('pt-BR')
  }

  const bgColor = isAlert ? 'bg-red-100 dark:bg-red-900' : 'bg-blue-100 dark:bg-blue-900'
  const textColor = isAlert ? 'text-red-900 dark:text-red-100' : 'text-blue-900 dark:text-blue-100'

  return (
    <div className={`${bgColor} rounded-lg p-6`}>
      <p className={`text-sm font-medium ${textColor}`}>{label}</p>
      <p className={`text-3xl font-bold ${textColor} mt-2`}>{formatValue()}</p>
    </div>
  )
}
